import mongoose from 'mongoose';

import cryptoPaymentSchema from '../schemas/crypto-payment';

export default (mongoose.models.CryptoPayment ||
  mongoose.model('CryptoPayment', cryptoPaymentSchema)) as mongoose.Model<any>;
